import { cn } from 'lib/utils';
import { FC, ReactNode } from 'react';
import { cardPadding } from './Card';

interface CardContentProps {
  children: ReactNode;
  padForTitleBar?: boolean;
  padSides?: boolean;
  loading?: boolean;
  className?: string;
}

const CardContent: FC<CardContentProps> = ({
  children,
  padForTitleBar = false,
  padSides = false,
  loading = false,
  className = null,
}) => (
  <div
    className={cn(
      'block relative top-0 left-0 w-full h-full min-h-full z-0 text-left', // h-auto
      padForTitleBar
        ? 'pt-[70px] @sm:pt-[75px] @md:pt-[82px] @lg:pt-[92px] @xl:pt-[104px] md:pt-[85px] md:@sm:pt-[90px] md:@md:pt-[87px] md:@lg:pt-[97px] md:@xl:pt-[104px]'
        : 'pt-0',
      padSides ? cardPadding.x : 'px-0',
      className ? className : ''
    )}
  >
    <span
      className={cn(
        'transition-opacity duration-300',
        loading ? 'opacity-0 pointer-events-none' : 'opacity-100'
      )}
    >
      {children}
      {/* <div className='block relative top-0 left-0 w-full h-full bg-orange-400/30' /> */}
    </span>
  </div>
);

export default CardContent;
